var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_552",
    "data-name": "Groupe 552",
    transform: "translate(-72.475 -54)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(72.475 54)",
    fill: "#fad86a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_361",
    "data-name": "Groupe 361",
    transform: "translate(78.164 60.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_516",
    "data-name": "Trac\\xE9 516",
    d: "M296.649,421.782H284.117a2.546,2.546,0,0,1-2.207-3.813l6.262-10.958a2.545,2.545,0,0,1,4.421,0l6.261,10.959a2.544,2.544,0,0,1-2.2,3.812Zm-12.53-1.623h12.524a.827.827,0,0,0,.466-.123.92.92,0,0,0,.337-1.257l-6.263-10.963a.923.923,0,0,0-1.6,0l-6.262,10.959a.921.921,0,0,0,.148,1.113.915.915,0,0,0,.651.27Zm4.757-12.745h0Z",
    transform: "translate(-281.572 -405.729)",
    fill: "#554613"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "rond",
    cx: 1.082,
    cy: 1.082,
    r: 1.082,
    transform: "translate(7.757 11.634)",
    fill: "#554613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "exclam",
    d: "M296.975,419.651a.554.554,0,0,1-.535.414.542.542,0,0,1-.526-.414l-.809-5.126a.5.5,0,0,1,.387-.579.431.431,0,0,1,.084-.008H297.3a.49.49,0,0,1,.478.5.521.521,0,0,1-.007.087Z",
    transform: "translate(-287.601 -408.876)",
    fill: "#554613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.aed9b231e27b878f84baa6d0596bf572.svg";
export { ForwardRef as ReactComponent };